import { Handle, Position } from '@xyflow/react'
import { SM_THEME as T } from './stateMachineTheme'
import { selectedBorder } from './selectedBorder.js'

export function StateOutputNode({ data, selected }) {
  const connected = data.connected ?? false
  return (
    <div style={{
      background: T.nodeBg,
      border: `2px solid ${selected ? selectedBorder(connected ? T.nodeBorderActive : T.nodeBorder) : connected ? T.nodeBorderActive : T.nodeBorder}`,
      borderRadius: 8,
      padding: '10px 14px',
      minWidth: 150,
      color: '#ddd',
      fontFamily: 'var(--m-font)',
      fontSize: 12,
      boxShadow: connected ? T.nodeGlowActive : 'none',
    }}>
      <div style={{ color: connected ? T.labelActive : T.labelState, fontWeight: 'bold', fontSize: 10, letterSpacing: 1, marginBottom: 6 }}>
        OUTPUT POSE
      </div>
      <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
        <Handle
          type="target"
          position={Position.Left}
          id="result"
          style={{ background: T.handle, width: 10, height: 10 }}
        />
        <span style={{ marginLeft: 18, color: connected ? T.breadcrumbName : T.hint, fontSize: 11 }}>
          {connected ? '◉ Result' : '○ Result'}
        </span>
      </div>
    </div>
  )
}
